import React, { useState } from "react";
import { Warehouse } from "./Warehouse";
import { FaAngleDown, FaPen, FaTrash } from "react-icons/fa";

export const RenderWarehouses = ({ warehouses = [], sendWarehouses, accounts = [], userId }) => {
  const [editingWarehouse, setEditingWarehouse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNewWarehouse = (e) => {
    e?.preventDefault();
    const newObj = {
      id: Math.floor(Math.random() * 100000),
      name: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      user_id: userId,
      emails: [{ name: "", email: "" }],
      accounts: accounts.map((a) => (typeof a === "object" ? a.account_no : a)),
      isNew: true,
    };
    setEditingWarehouse(newObj);
    setIsModalOpen(true);
  };

  const handleEditClick = (wh) => {
    setEditingWarehouse({ ...wh });
    setIsModalOpen(true);
  };

  const handleUpdateWarehouse = (updatedObj) => {
    let aux = [...warehouses];
    const index = aux.findIndex((w) => w.id === updatedObj.id);
    if (index !== -1) {
      aux[index] = updatedObj;
    } else {
      aux.push(updatedObj);
    }
    sendWarehouses(aux);
    setIsModalOpen(false);
    setEditingWarehouse(null);
  };

  const handleDeleteWarehouse = (id) => {
    let aux = warehouses.filter((w) => w.id !== id);
    sendWarehouses(aux);
  };

  return (
    <div className="multiform warehouses">
      <div className="tab-header">
        <h3 className="section-title personal">Warehouses</h3>
        <button className="new-trucker" type="button" onClick={handleNewWarehouse}>
          <p>New Warehouse</p>
        </button>
      </div>

      <div className="divisor"></div>

      <div className="table-container warehouses-table-wrapper">
        <table className="settings-table">
          <thead>
            <tr>
              <th>
                Name <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Address <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Contact Name <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Phone Number <FaAngleDown className="sort-icon" />
              </th>
              <th>
                Account <FaAngleDown className="sort-icon" />
              </th>
              <th className="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {warehouses && warehouses.length > 0 ? (
              warehouses.map((wh, i) => {
                const fullAddress = [wh.address, wh.city, wh.state, wh.zip]
                  .filter(Boolean)
                  .join(", ");
                const contactName = wh.emails?.[0]?.name || wh.contact_name || "-";
                const phone = wh.phone || "-";

                const accountDisplay = Array.isArray(wh?.accounts) && wh.accounts.length > 0
                  ? wh.accounts.join(", ")
                  : accounts.length > 0
                  ? accounts.map(a => typeof a === 'object' ? a.account_no : a).join(", ")
                  : "-";

                return (
                  <tr key={wh.id || i}>
                    <td className="font-bold">{wh.name || "—"}</td>
                    <td>{fullAddress || "-"}</td>
                    <td>{contactName}</td>
                    <td>{phone}</td>
                    <td>{accountDisplay}</td>
                    <td className="actions-cell">
                      <button
                        type="button"
                        className="action-btn edit-btn"
                        onClick={() => handleEditClick(wh)}
                        title="Edit Warehouse"
                      >
                        <FaPen />
                      </button>
                      <button
                        type="button"
                        className="action-btn delete-btn"
                        onClick={() => handleDeleteWarehouse(wh.id)}
                        title="Delete Warehouse"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="empty-table">
                  No warehouses found. Click "New Warehouse" to add one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && editingWarehouse && (
        <Warehouse
          warehouseInfo={editingWarehouse}
          accounts={accounts}
          onSave={handleUpdateWarehouse}
          onClose={() => {
            setIsModalOpen(false);
            setEditingWarehouse(null);
          }}
        />
      )}
    </div>
  );
};